import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class CustomerApi extends CrudBase {

  search = (text) => axios.get(`${this.endpoint}/get-by?text=${text}`);

  defaultMethods = {
    search: this.search,
  }
};

const customer = new CustomerApi('api/v1/customer');

export default customer.defaultMethods;
